export default "__VITE_ASSET__DEB4TqTn__"